// extracted by mini-css-extract-plugin
module.exports = {"paginationWrap":"bw_QE","selected":"ZJQcK","arrowBtn":"t9TPy","disabled":"M5Den","prevButton":"wZ0cV","nextButton":"MrSbc"};